module.exports = __webpack_public_path__ + "img/tow-truck.9107fc79.svg";